import { FC, ReactNode } from "react";
import { GenericMessage } from "components/feedback/Message";
import { CommercialIcon } from "components/icons/customIcons";
import { CardsSection } from "components/layout/Section/CardsSection";

interface CopropertyStepLayoutProps {
  title: string;
  /** Message d'aide en tête de la carte principale (bandeau info générique). */
  message?: string;
  /** Petites cartes de la colonne de gauche (fiche copropriété, avancement, rail…). */
  aside?: ReactNode;
  children: ReactNode;
}

/**
 * Cadre commun des sous-étapes copropriété du dossier MRI, calqué sur l'écran locataires
 * de la GLI : `CardsSection` titrée avec l'icône immeuble, colonne de gauche en petites
 * cartes, carte principale blanche à droite qui empile un message d'aide et des sections.
 */
export const CopropertyStepLayout: FC<CopropertyStepLayoutProps> = ({ title, message, aside, children }) => (
  <CardsSection icon={<CommercialIcon className="h-8 w-8 text-primary" />} title={title}>
    <div className="grid grid-cols-12 gap-4">
      {aside && <div className="col-span-12 space-y-4 lg:col-span-3">{aside}</div>}
      <div className={`col-span-12 space-y-4 rounded-xl bg-white p-4 shadow ${aside ? "lg:col-span-9" : ""}`}>
        {message && <GenericMessage message={message} type="info" dismissible={false} />}
        {children}
      </div>
    </div>
  </CardsSection>
);

interface CopropertySectionProps {
  title: string;
  titleAside?: ReactNode;
  children: ReactNode;
}

/** Section titrée de la carte principale (« Surfaces », « Bâtiments »…), comme « Propriétaires » / « Locataires » en GLI. */
export const CopropertySection: FC<CopropertySectionProps> = ({ title, titleAside, children }) => (
  <section className="space-y-3">
    <div className="flex items-center justify-between gap-4">
      <h3 className="text-lg font-semibold">{title}</h3>
      {titleAside}
    </div>
    {children}
  </section>
);
